import React, { FC, useEffect, useState } from 'react'
import { Alert, Button, Col, Input, Row, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import ResultModal from './ResultModal'
import { Link, useHistory } from 'react-router-dom'
import paths from '../../routes/paths'
import Icon from '../../components/Icon'
import { storageApi } from '../../api'
import { IResultDetail } from '../../types/results'

interface IResult {
  key: React.Key
  name: string
  access: number
  createdDate: string
  createdBy: string
  notes: string
  comments: string
  summary: string
}

export const resultTableDataSource: IResult[] = [...new Array(20)].map((_, idx) => ({
  key: idx,
  name: `Result ${idx}`,
  access: idx,
  createdDate: new Date().toISOString(),
  createdBy: 'Ratio Technologies',
  notes:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tempor tellus non pretiumconsectetur. Sed nec lorem lorem. Proin vitae rhoncus lectus. Praesent neque ante, dignissimac magna in, mattis venenatis mi. Sed eu tellus tortor. Nam a urna vel nisi tincidunt porta.',
  comments:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tempor tellus non pretiumconsectetur. Sed nec lorem lorem. Proin vitae rhoncus lectus. Praesent neque ante, dignissimac magna in, mattis venenatis mi. Sed eu tellus tortor. Nam a urna vel nisi tincidunt porta.',
  summary:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tempor tellus non pretiumconsectetur. Sed nec lorem lorem. Proin vitae rhoncus lectus. Praesent neque ante, dignissimac magna in, mattis venenatis mi. Sed eu tellus tortor. Nam a urna vel nisi tincidunt porta.',
}))

export const resultsTableColumn: ColumnsType<IResultDetail> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt) => new Date(createdAt).toLocaleString(),
    sorter: (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  },
  {
    title: 'Access',
    dataIndex: 'accesLevel',
    key: 'accesLevel',
    // render: (accessCount: number) =>
    //   [...new Array(Math.round(accessCount / 5))].map((_, idx) => (
    //     <Tag key={idx} color='blue'>
    //       Role {idx + 1}
    //     </Tag>
    //   )),
  },
  {
    title: 'Created By',
    dataIndex: 'createdBy',
    key: 'createdBy',
  },
  {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    align: 'center',
    render: (_, result) => (
      <Link to={paths.getResultDetailPath(result.id)}>
        <Button type='primary'>Detail</Button>
      </Link>
    ),
  },
]

const Results: FC = () => {
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true)
  const [results, setResults] = useState<IResultDetail[]>([])
  const [selectedResult, setSelectedResult] = useState<IResultDetail>()
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])

  async function fetchResults() {
    try {
      setIsLoading(true)
      const resultsResponse = await storageApi.fetchResults()
      setResults(resultsResponse)
      setIsLoading(false)
    } catch {
      setResults([])
    }
  }

  // async function deleteResult(resultId: string) {
  //   setIsLoading(true)
  //   await storageApi.deleteResult(resultId)
  //   fetchResults()
  // }

  function selectResult(result: IResultDetail) {
    setSelectedResult(result)
    setIsDetailModalVisible(true)
  }
  function compareResults() {
    if (selectedRowKeys.length === 2) {
      console.log(
        paths.getResultComparisonPath(selectedRowKeys[0].toString(), selectedRowKeys[1].toString()),
      )
      history.push(
        paths.getResultComparisonPath(selectedRowKeys[0].toString(), selectedRowKeys[1].toString()),
      )
    }
  }

  useEffect(() => {
    fetchResults()
  }, [])

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[]) => {
      if (selectedRowKeys.length > 2) return
      return setSelectedRowKeys(selectedRowKeys)
    },
    // getCheckboxProps: (record: DataType) => ({
    //   disabled: record.name === 'Disabled User', // Column configuration not to be checked
    //   name: record.name,
    // }),
  }

  return (
    <div>
      <Alert
        type='info'
        message={<Typography.Title level={4}>Results</Typography.Title>}
        description='Compare and and investigate detailed results for each simulation.'
      />

      <Row align='middle' gutter={20}>
        <Col flex={1}>
          <Input.Search className='my-24' placeholder='Search' onChange={fetchResults} />
        </Col>
        {selectedRowKeys.length === 2 && (
          <Col>
            <Button type='primary' icon={<Icon icon='right-left' />} onClick={compareResults}>
              Compare
            </Button>
          </Col>
        )}
        {selectedRowKeys.length ? (
          <Col>
            <Button type='dashed' onClick={() => setSelectedRowKeys([])}>
              Deselect All
            </Button>
          </Col>
        ) : null}
      </Row>
      <Table
        rowClassName='cursor-pointer'
        rowKey='id'
        columns={resultsTableColumn}
        dataSource={results}
        loading={isLoading}
        bordered
        onChange={fetchResults}
        onRow={(result) => {
          return {
            // onClick: () => selectResult(result),
          }
        }}
        rowSelection={{
          ...rowSelection,
          hideSelectAll: true,
        }}
      />

      <ResultModal
        title={selectedResult?.id}
        comments={selectedResult?.comments}
        // summary={selectedResult?.summary}
        // accesses={[...new Array(selectedResult?.access || 5)].map(() => ({
        //   name: 'Ratio Technologies',
        // }))}
        visible={isDetailModalVisible}
        onCancel={() => setIsDetailModalVisible(false)}
      />
    </div>
  )
}

export default Results
